import DonationsTable from '../Components/DonationsTable';
import { useTranslation } from 'react-i18next';
import useHeader from '@hooks/useHeader';
import { useMemo } from 'react';
import { Box } from '@mui/material';
import Filters from '@Components/Specific/Filters/Filters';
import { donationFilters } from '@Components/Specific/Filters/filterSets';
import {
    DeleteOutlineRounded,
    FileUploadRounded,
    GetAppRounded,
    GroupAddRounded,
} from '@mui/icons-material';
import QuickOptions from '@Components/General/QuickOptions';
import axiosInstance from '@api/axiosInstance';
import { useMutation, useSuspenseQuery } from '@tanstack/react-query';
import useDialog from '@hooks/useDialog';
import { useLoaderDeps, useNavigate } from '@tanstack/react-router';
import { donationsQueryOptions } from '@utils/queryOptions';
import usePagination from '@hooks/usePagination';
import useSort from '@hooks/useSort';
import useSearchFilters from '@hooks/useSearchFilters';
import useCheckedItems from '@hooks/useCheckedItems';

const Donations = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { data, refetch } = useSuspenseQuery(
        donationsQueryOptions(useLoaderDeps({})),
    );

    const { results: donations, count } = data || {};

    const { page, setPage, pageCount, pageSize, setPageSize } = usePagination(
        count,
        'donations',
    );

    const { getSort, setSort } = useSort();

    const {
        filters: filterParams,
        addFilter: addParam,
        hasFilter,
        exportFilters,
        removeFilter: removeParam,
    } = useSearchFilters();

    const { checkedItems, handleToggle, setCheckedItems } = useCheckedItems();

    const deleteDialog = useDialog();

    const { mutate: deleteDonation } = useMutation({
        mutationFn: () =>
            axiosInstance.delete('/donations', { data: checkedItems }),
        onSuccess: () => {
            refetch();
            setCheckedItems([]);
            deleteDialog.close();
        },
    });

    const quickActions = [
        {
            label: t('Upload'),
            action: () => console.log('Upload Donations'),
            startIcon: <FileUploadRounded />,
        },
    ];

    const headerProps = useMemo(() => {
        return {
            title: t('Donations'),
            quickActions,
            fabAction: () => () => navigate('new'),
            searchProps: {
                searchPlacholder: t('What are you looking for?'),
            },
        };
    }, []);

    useHeader(headerProps);

    const donationsOptions = [
        {
            label: `${t('Delete')} ${checkedItems.length || ''} ${t(
                'Donations',
            )}`,
            Icon: DeleteOutlineRounded,
            onClick: () => deleteDialog.open({ onDelete: deleteDonation }),
        },
        {
            label: t('Export'),
            onClick: () => console.log('Export'),
            Icon: GetAppRounded,
            quickButton: true,
        },
        {
            label: t('Add to Group'),
            onClick: () => console.log('Add to Group'),
            Icon: GroupAddRounded,
        },
    ];

    return (
        <>
            <Box
                display="flex"
                // alignItems="center"
                justifyContent="space-between"
                my={1.5}
            >
                <Box>
                    <Filters
                        filterSet={donationFilters}
                        addFilter={addParam}
                        filters={filterParams}
                        removeFilter={removeParam}
                    />
                </Box>
                <Box>
                    <QuickOptions options={donationsOptions} />
                </Box>
            </Box>
            <DonationsTable
                donations={donations || []}
                pageSize={pageSize}
                setPageSize={setPageSize}
                count={count}
                checkedDonations={checkedItems}
                toggleCheckItem={handleToggle}
                setCheckedDonations={setCheckedItems}
                getSort={getSort}
                onSortChange={setSort}
                pageCount={pageCount}
                page={page}
                setPage={setPage}
            />
        </>
    );
};

export default Donations;
